import axios from "axios";
import { empty, debounce } from "../sdk/utils";
import { ElMessage } from "element-plus";
import { getUserInfo } from '../sdk/utils.js';
const userInfo = getUserInfo(); // 用户信息

// 全局请求封装
export const DOMAIN_PREFIX = "https://admin.nssxgh.cn"; // 接口域名前缀
export const API_BASE_URL = "https://api.nssxgh.cn"; // 图片域名前缀-犀牛云
// export const API_BASE_URL = "https://admin.nssxgh.cn"; // 图片域名前缀-犀牛云
let API_URL = API_BASE_URL
if (userInfo.type == 'BXS') {
	API_URL = DOMAIN_PREFIX;
}

export const STATIC_URL = API_BASE_URL + "/static/wxxcx"; // 静态文件地址

export const base_url = "http://192.168.1.5:9007"; //本地地址

// 请求环境需与项目接口保持一致
// const api_url = base_url;
// const api_url = API_URL;

const INTERFACE_TIMEOUT = 10000; // 接口超时时间

// 配置http
let http = axios.create({
	baseURL: API_URL,
	timeout: 5000,
	custom: {
		isAuth: true,
		isLoading: true,
		isErrorMsg: true,
		isTimeout: false,
	},
});

// 添加请求拦截器
http.interceptors.request.use(
	function (config) {
		if (empty(config.params)) config.params = {};

		// token
		if (config.custom.isAuth) {
			let token = localStorage.getItem("token");
			// let token = "Bearer eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiI1YWE5NzI0YTNlZTQ0MGVhODIwZTE0N2MzNDZkNWJkZCIsInVzZXIiOiIxODYwMjUyMjAzOCIsInN1YiI6IjE4NjAyNTIyMDM4In0.ohJmiQ86L3ZRmZYoTz2ZUbZmI3pc7wvfTxj25n9IJmYyZMxMwoYGeL2qVG54kL872kxOH-Qi5fPjCPyP67pUHw"
			if (userInfo.type == 'BXS') {
				if (!empty(token)) config.headers["Authorization-business"] = token;
			} else {
				if (!empty(token)) config.headers.Authorization = token;
			}
		}
		// 判断参数是否需要长时间接口相应
		if (config.custom.isTimeout) {
			config.timeout = INTERFACE_TIMEOUT;
		}

		// 在发送请求之前做些什么
		return config;
	},
	function (error) {
		// 对请求错误做些什么
		return Promise.reject(error);
	},
);

// 添加响应拦截器
http.interceptors.response.use(
	function (response) {
		let config = response.config;
		let res = response.data;
		// console.log(60, "response", response);
		// console.log(61, "res", res);
		if (!empty(res.code) && res.code != 200) {
			switch (res.code) {
				case "20005":
					debounceLogin();
					break;
				case "20004":
					debounceLogin();
					break;
				case "910101":
					break;
				default:
					if (config.custom.isErrorMsg) {
						ElMessage({
							message: res.message,
							type: "error",
						});
					}
			}
			return Promise.reject(response);
		} else {
			return response?.data?.data;
		}
	},
	function (error) {
		// console.log(85, error);
		// 对响应错误做点什么
		return Promise.reject(error);
	},
);

// 防抖处理多接口token校验弹框过多的问题
const debounceLogin = debounce(
	() => {
		ElMessage({
			message: "登录失效，请重新登录",
			type: "error",
		});
	},
	800,
	false,
);

// 添加文件上传方法（带进度监听）
http.uploadWithProgress = function (url, data, onUploadProgress, config = {}) {
	// 合并配置
	const mergedConfig = {
		...config,
		onUploadProgress: onUploadProgress,
		headers: {
			"Content-Type": "multipart/form-data",
			...config.headers,
		},
	};

	return this.post(url, data, mergedConfig);
};

export { http as request };
